export default "__VITE_ASSET__L8Taljhk__"